import { produce } from 'immer';

import { reducer as coreReducer, defaultState as defaultStateCore } from '@core/js/components/system/Page/store/reducer';

import * as Types from './buzz/types';
import { actionTypes } from './buzz/constants';

export const defaultState: Types.IPageState = {
    ...defaultStateCore,
    isSticky: false,
    isStickyHeader: false,
    isStickyFooter: true,
    webContentLoadings: {},
    footerClassName: ''
};

export const reducer = produce((draftState, action: Types.TPageAction): Types.IPageState | void => {
    switch (action.type) {
        case actionTypes.SET_IS_STICKY_FOOTER: {
            Object.assign(draftState, {
                isStickyFooter: action.payload
            });
            break;
        }
        case actionTypes.SET_IS_STICKY_HEADER: {
            Object.assign(draftState, {
                isStickyHeader: action.payload
            });
            break;
        }
        case actionTypes.SET_WEB_CONTENT_LOADINGS: {
            if (action.payload.isLoading) {
                draftState.webContentLoadings[action.payload.webContentId] = action.payload.isLoading;
            } else {
                delete draftState.webContentLoadings[action.payload.webContentId];
            }
            break;
        }
        case actionTypes.SET_FOOTER_CLASSNAME: {
            Object.assign(draftState, {
                footerClassName: action.payload
            });
            break;
        }
        default:
            return coreReducer(draftState, action) as Types.IPageState;
    }
}, defaultState);
